import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { fadeIn } from "../../animations/Animations";

const StyledPostPreview = styled.div`
  padding: 16px 0;
  .programPostLink {
    color: black;
    text-decoration: none;
  }
  .programPostPreview {
    display: grid;
    grid-template-columns: 125px auto 2rem;
    grid-column-gap: 2rem;
    align-items: center;

    .imageWrapper {
      width: 125px;
      height: 70.5px;
      img {
        opacity: 0;
        animation: ${fadeIn} 600ms ease forwards;
      }
    }
    .checkMark {
      background: ${(props) => props.theme.primaryBlue};
      color: white;
      width: 2rem;
      height: 2rem;
      border-radius: 50%;
      font-size: 20px;
      text-align: center;
    }

    .postTitle {
      font-size: 16px;
      font-family: "Roboto", sans-serif;
    }
    @media (max-width: ${(props) => props.theme.breakPoints.mobile}) {
      grid-template-columns: auto 2rem;
      grid-gap: 1rem;
      .imageWrapper {
        grid-column: 1/3;
      }
    }
  }
`;

const ProgramPostPreview = ({ post, completedTokens, currentPath }) => {
  let completed = false;
  if (completedTokens.indexOf(post.programPostId) > -1) {
    completed = true;
  }
  return (
    <StyledPostPreview>
      <Link
        to={`${currentPath}/post/${post.programPostId}`}
        className="programPostLink"
      >
        <div className="programPostPreview">
          <div className="imageWrapper">
            <img src={`${post.thumbnail}?q=50&w=250`} alt="" width="100%" />
          </div>
          <h3 className="postTitle">{post.programPostTitle}</h3>
          {completed && <div className="checkMark">&#10004;</div>}
        </div>
      </Link>
    </StyledPostPreview>
  );
};

export default ProgramPostPreview;
